import { makeStyles, shorthands } from "@griffel/react";
import { comboboxClassNames } from "@fluentui/react-components";

export const comboMatchedInputStyles = {
  ...shorthands.border("1px", "solid", "#357C7C"),
  ...shorthands.borderRadius("4px"),
  "--colorCompoundBrandStroke": "#00000000",
  "--colorCompoundBrandStrokeHover": "#00000000",
  "--colorCompoundBrandStrokePressed": "#00000000",
  ":focus-within": {
    ...shorthands.border("1px", "solid", "#357C7C"),
    outline: "none",
    boxShadow: "none",
  },
  "::after": {
    display: "none",
  },
  "& input": {
    fontFamily: "Segoe UI",
    fontSize: "12px",
    color: "#333333",
  },
};

export const useComboboxStyles = makeStyles({
  dropdownMenuCompose: {
    ...shorthands.padding("0px"),
    ...shorthands.gap("3px"),
    ...shorthands.border("1px", "solid", "#357C7C"),
    minWidth: "0",
    height: "36.5px",
    ...shorthands.flex("none"),
    alignSelf: "stretch",
    "--colorCompoundBrandStroke": "#00000000",
    "--colorCompoundBrandStrokeHover": "#00000000",
    "--colorCompoundBrandStrokePressed": "#00000000",
    "::after": {
      display: "none",
    },
    ":focus-within": {
      ...shorthands.border("1px", "solid", "#357C7C"),
      outline: "none",
      boxShadow: "none",
    },
    [`& .${comboboxClassNames.input}`]: {
      alignSelf: "stretch",
      height: "100%",
      width: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      fontFamily: "Segoe UI",
      fontSize: "12px",
      color: "#333333",
    },
    [`& .${comboboxClassNames.expandIcon}`]: {
      alignSelf: "center",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  dropdownMenuListbox: {
    ...shorthands.border("1px", "solid", "#357C7C"),
    maxHeight: "240px",
    overflowY: "auto",
    boxSizing: "border-box",
  },
  comboBoxInput: {
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    fontFamily: "Segoe UI",
    fontSize: "12px",
    color: "#333333",
    outline: "none !important",
    boxShadow: "none",
    border: "none",
    ":focus": {
      outline: "none !important",
      boxShadow: "none",
    },
    ":focus-visible": {
      outline: "none !important",
      boxShadow: "none",
    },
    "&:focus::after": {
      display: "none",
    },
  },
  optionText: {
    fontFamily: "Segoe UI",
    fontSize: "12px",
    color: "#333333",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  optionTextColumn: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flexGrow: 1,
    flexShrink: 1,
  },
  optionMetaText: {
    fontFamily: "Segoe UI",
    fontSize: "10px",
    lineHeight: "12px",
    color: "#757575",
    marginTop: "5px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  comboMatchedInput: comboMatchedInputStyles,
});

export const UPLOAD_FOLDER_LISTBOX_CLASS = "uploadFolderListbox";

/** Keep listboxes above/below the trigger; avoid left/right fallback in narrow panes. */
export const comboboxPositioning = {
  position: "below",
  fallbackPositions: ["above"],
  align: "start",
  autoSize: "width",
};

export const comboboxListboxProps = (listboxClassName) => ({
  className: `hideCheckIcon ${listboxClassName}`,
});

export const uploadFolderListboxProps = (listboxClassName) => ({
  className: `hideCheckIcon ${UPLOAD_FOLDER_LISTBOX_CLASS} ${listboxClassName}`,
});
